import sendEventToPiano from './send_event_to_piano';

export default class AtInternetManagingCandidate {
  static sendValidateCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click valider_candidat' });
  }

  static sendValidateCandidatsEvent() {
    sendEventToPiano('click.action', { 'click': 'click valider_candidats' });
  }

  static sendValidationDeleteCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click validation_supprimer_candidat' });
  }

  static sendDeleteMemberEvent() {
    sendEventToPiano('click.action', { 'click': 'click supprimer_membre' });
  }

  static sendReCallCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click relancer_candidat' });
  }

  static sendRefuseCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click refuser_candidat' });
  }

  static sendEditMemberEvent() {
    sendEventToPiano('click.action', { 'click': 'click modifier_membre' });
  }

  static sendEditCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click modifier_candidat' });
  }

  static sendExportCandidatsEvent() {
    sendEventToPiano('click.action', { 'click': 'click export_candidats' });
  }

  static sendAskAddCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click demande_ajout_candidat' });
  }

  static sendInternCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click candidat_interne' });
  }

  static sendExternCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click candidat_externe' });
  }

  static sendAddCandidatEvent() {
    sendEventToPiano('click.action', { 'click': 'click ajout_candidat' });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/at_internet/managing_candidate.js